import { render, staticRenderFns } from "./SetPoints.vue?vue&type=template&id=2d25639d&"
import script from "./SetPoints.vue?vue&type=script&lang=js&"
export * from "./SetPoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports